import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getCsrfToken } from "../services/authService";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../styles/Login.css";

export default function ResetPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");

  const [form, setForm] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!token) {
      setError(t("resetPassword.invalidToken"));
      return;
    }

    if (form.newPassword !== form.confirmPassword) {
      setError(t("resetPassword.passwordsDontMatch"));
      return;
    }

    try {
      const csrf = await getCsrfToken();

      const response = await fetch("/api/auth/reset-password", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          [csrf.headerName]: csrf.token,
        },
        body: JSON.stringify({
          token,
          newPassword: form.newPassword,
        }),
      });

      if (!response.ok) {
        setError(t("resetPassword.error"));
        return;
      }

      navigate("/login", { replace: true });
    } catch {
      setError(t("resetPassword.error"));
    }
  };

  return (
    <main className="login-page">
      <section className="login-card">
        <h1>{t("resetPassword.title")}</h1>
        <p className="login-subtitle">{t("resetPassword.subtitle")}</p>

        <form onSubmit={handleSubmit} className="login-form">
          <label>
            {t("resetPassword.newPassword")}

            <div className="password-field">
              <input
                type={showNewPassword ? "text" : "password"}
                name="newPassword"
                value={form.newPassword}
                onChange={handleChange}
                autoComplete="new-password"
                required
              />

              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowNewPassword(!showNewPassword)}
                aria-label="Mostrar contraseña"
              >
                {showNewPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </label>

          <label>
            {t("resetPassword.confirmPassword")}

            <div className="password-field">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
                autoComplete="new-password"
                required
              />

              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                aria-label="Mostrar contraseña"
              >
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </label>

          {error && <p className="login-error">{error}</p>}

          <button type="submit" className="login-button">
            {t("resetPassword.submit")}
          </button>
        </form>

        <div className="login-links">
          <Link to="/login">{t("resetPassword.backToLogin")}</Link>
        </div>
      </section>
    </main>
  );
}